export enum EntitlementDuration {
  weekly = "weekly",
  monthly = "monthly",
  yearly = "yearly",
  lifetime = "lifetime",
}
